export default {
  props: ['models'],
  methods: {
    onUpdateItemActivity(item, updated_item) {
      this.models[this.models.indexOf(item)].is_active = updated_item.is_active
    },
    onDeleteItem(item) {
      const index = this.models.indexOf(item);

      if (index > -1) {
        this.models.splice(index, 1);
      }
    }
  }
}
